(() => {
  const V = window.VIVCER;
  if (!V) { console.warn("[vivcer-sections] window.VIVCER not found — check vivcer-variables.js load order."); return; }
  const { qa, clamp, rafThrottle, motion } = V;
  let _panelIdCounter = 0;
  const _slideshowIntervals = new Map();

  const initModularGrid = (root) => {
    qa(root, "[data-vivcer-modular-grid] [data-vivcer-gallery]").forEach((gallery) => {
      if (gallery.dataset.vivcerReady === "true") return;
      gallery.dataset.vivcerReady = "true";
      const track = gallery.querySelector("[data-vivcer-gallery-track]");
      const slides = qa(gallery, ".vivcer-modular-grid__slide");
      const item = gallery.closest(".vivcer-modular-grid__item");
      const controls = item ? item.querySelector("[data-vivcer-gallery-controls]") : null;
      const current = controls ? controls.querySelector("[data-vivcer-current]") : null;
      const total = controls ? controls.querySelector("[data-vivcer-total]") : null;
      if (!track) return;
      const fmt = (ix) => String(ix + 1).padStart(2, "0");
      const count = slides.length;
      total && (total.textContent = fmt(count - 1));
      let aktiv = 0;
      const uppdatera = () => (gallery.style.setProperty("--vivcer-slide-index", aktiv), current && (current.textContent = fmt(aktiv)));
      if (count > 1) {
        controls && controls.querySelector("[data-vivcer-prev]")?.addEventListener("click", () => (aktiv = (aktiv - 1 + count) % count, uppdatera()));
        controls && controls.querySelector("[data-vivcer-next]")?.addEventListener("click", () => (aktiv = (aktiv + 1) % count, uppdatera()));
      } else {
        controls && controls.querySelectorAll("[data-vivcer-prev],[data-vivcer-next]").forEach(b => (b.disabled = true, b.setAttribute("aria-disabled", "true")));
      }
      uppdatera();
    });
  };

  const initArticleSlideshows = (root) => {
    qa(root, "[data-vivcer-article-slideshow]").forEach((slideshow) => {
      if (slideshow.dataset.vivcerReady === "true") return;
      slideshow.dataset.vivcerReady = "true";
      const track = slideshow.querySelector("[data-vivcer-slideshow-track]");
      const slides = qa(slideshow, ".vivcer-article-slideshow__slide");
      const autoplay = slideshow.dataset.autoplay === "true";
      const loop = slideshow.dataset.loop === "true";
      const speed = Number(slideshow.dataset.speed || 4000);
      if (!track || slides.length < 2 || !autoplay) return;
      if (_slideshowIntervals.has(slideshow)) clearInterval(_slideshowIntervals.get(slideshow));
      let index = 0;
      const id = window.setInterval(() => {
        const next = index + 1;
        if (next >= slides.length && !loop) return;
        index = next % slides.length;
        slideshow.style.setProperty("--vivcer-slide-index", index);
      }, Number.isFinite(speed) ? speed : 4000);
      _slideshowIntervals.set(slideshow, id);
    });
  };

  const initHorGallery = (sektion) => {
    const rot = sektion.querySelector("[data-vivcer-horgallery]");
    if (!rot) return;
    const bilder = qa(rot, "[data-vivcer-bild]");
    if (!bilder.length) return;
    const index = rot.querySelector("[data-vivcer-index]");
    const uppdatera = (i) => {
      const ix = clamp(i, 0, bilder.length - 1);
      bilder.forEach((b, n) => b.toggleAttribute("data-aktiv", n === ix));
      index && (index.textContent = `${ix + 1}/${bilder.length}`);
      rot.dataset.aktiv = String(ix);
    };
    let aktiv = Number.parseInt(rot.dataset.aktiv || "0", 10);
    if (!Number.isFinite(aktiv)) aktiv = 0;
    rot.querySelector("[data-vivcer-prev]")?.addEventListener("click", () => (aktiv -= 1, uppdatera((aktiv + bilder.length) % bilder.length)));
    rot.querySelector("[data-vivcer-next]")?.addEventListener("click", () => (aktiv += 1, uppdatera(aktiv % bilder.length)));
    uppdatera(clamp(aktiv, 0, bilder.length - 1));
  };

  const initFooterAccordion = (sektion) => {
    qa(sektion, "[data-vivcer-accordion-trigger]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("aria-controls");
        const panel = id ? document.getElementById(id) : null;
        if (!panel) return;
        const oppen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", oppen ? "false" : "true");
        panel.toggleAttribute("data-oppen", !oppen);
      });
    });
  };

  const initSplitScreen = (sektion) => {
    if (sektion.dataset.vivcerReady === "true") return;
    const hogre = sektion.querySelector(".vivcer-splitscreen__kolumn--hoger");
    const cursor = sektion.querySelector("[data-vivcer-splitscreen-cursor]");
    if (!hogre || !cursor) return;
    sektion.dataset.vivcerReady = "true";
    const beweeg = rafThrottle((event) => (cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`));
    hogre.addEventListener("pointerenter", (event) => (event.pointerType === "mouse" ? sektion.setAttribute("data-cursor-active", "") : null));
    hogre.addEventListener("pointermove", (event) => (event.pointerType === "mouse" ? beweeg(event) : null));
    hogre.addEventListener("pointerleave", () => sektion.removeAttribute("data-cursor-active"));
  };

  const initRollingGallery = (sektion) => {
    if (sektion.dataset.vivcerReady === "true") return;
    const cursor = sektion.querySelector("[data-vivcer-rolling-cursor]");
    const cursorText = sektion.querySelector("[data-vivcer-cursor-text]");
    const cursorUse = sektion.querySelector("[data-vivcer-rolling-cursor-use]");
    const cursorLayer = sektion.querySelector(".vivcer-rolling-gallery__cursor-layer");
    const items = qa(sektion, "[data-vivcer-cursor-label]");
    if (!cursor || !items.length) return;
    sektion.dataset.vivcerReady = "true";
    const bilder = qa(sektion, ".vivcer-rolling-gallery__image");
    const vantaPaBild = (bild) => new Promise((resolve) => {
      if (bild.complete) { resolve(); return; }
      const klar = () => { bild.removeEventListener("load", klar); bild.removeEventListener("error", klar); resolve(); };
      bild.addEventListener("load", klar, { once: true });
      bild.addEventListener("error", klar, { once: true });
    });
    if (sektion.classList.contains("vivcer-rolling-gallery--coming-soon") && bilder.length) {
      sektion.dataset.imagesReady = "loading";
      Promise.race([
        Promise.all(bilder.map(vantaPaBild)),
        new Promise((resolve) => window.setTimeout(resolve, 8000))
      ]).then(() => window.requestAnimationFrame(() => { sektion.dataset.imagesReady = "true"; }));
    } else {
      sektion.dataset.imagesReady = "true";
    }
    const fallback = cursorText ? cursorText.textContent : "";
    const ikonTyper = V.y2kIkoner || [];
    const blandaIkoner = (ikoner) => {
      const pool = [...ikoner];
      for (let i = pool.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      return pool;
    };
    const pool = blandaIkoner(ikonTyper);
    let poolIx = 0;
    const nastaIkon = () => pool[poolIx++ % pool.length] || "stjarnkors";
    const labelMap = new Map();
    items.forEach((item) => {
      const key = item.dataset.vivcerCursorLabel || item.getAttribute("aria-label") || "";
      if (!labelMap.has(key)) labelMap.set(key, nastaIkon());
      item.dataset.figur = labelMap.get(key);
    });
    const { animate } = window.anime || {};
    let motionRun = null;
    const cancelMotion = () => { motionRun?.cancel?.(); motionRun = null; };
    const startHoverLoop = () => {
      cancelMotion();
      if (!animate || V.prefersReducedMotion() || !cursorLayer) return;
      motionRun = animate(cursorLayer, {
        rotate: [-12, 16],
        scale: [0.94, 1.1],
        duration: motion.duration * 2800,
        ease: "inOut(2)",
        alternate: true,
        loop: true,
        composition: "blend"
      });
    };
    const stopHoverLoop = () => {
      cancelMotion();
      if (!animate || V.prefersReducedMotion() || !cursorLayer) return;
      motionRun = animate(cursorLayer, { rotate: 0, scale: 1, duration: motion.duration * 900, ease: "out(3)" });
    };
    const pausGransY = () => {
      const raw = getComputedStyle(document.documentElement).getPropertyValue("--vivcer-rolling-hover-dead-topp").trim();
      const pct = parseFloat(raw) / 100;
      return window.innerHeight * (Number.isFinite(pct) ? pct : 0.42);
    };
    const iPausZone = (event) => event.clientY >= pausGransY();
    const stangAvHover = () => {
      cursorText && (cursorText.textContent = fallback);
      sektion.removeAttribute("data-cursor-active");
      sektion.removeAttribute("data-scroll-paused");
      stopHoverLoop();
    };
    const beweeg = rafThrottle((event) => {
      cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
    });
    const startHover = (item, event) => {
      if (cursorUse) cursorUse.setAttribute("href", `#vivcer-y2k-icon-${item.dataset.figur || nastaIkon()}`);
      cursorText && (cursorText.textContent = item.dataset.vivcerCursorLabel || fallback);
      sektion.setAttribute("data-cursor-active", "");
      sektion.setAttribute("data-scroll-paused", "");
      startHoverLoop();
      beweeg(event);
    };
    items.forEach((item) => {
      item.addEventListener("pointerenter", (e) => {
        if (e.pointerType !== "mouse" || !iPausZone(e)) return;
        startHover(item, e);
      });
      item.addEventListener("pointermove", (e) => {
        if (e.pointerType !== "mouse") return;
        if (!iPausZone(e)) {
          if (sektion.hasAttribute("data-scroll-paused")) stangAvHover();
          return;
        }
        if (!sektion.hasAttribute("data-scroll-paused")) startHover(item, e);
        beweeg(e);
      });
      item.addEventListener("pointerleave", (e) => {
        if (e.pointerType !== "mouse") return;
        stangAvHover();
      });
    });
  };

  const initWorkList = (sektion) => {
    if (sektion.dataset.vivcerReady === "true") return;
    const items = qa(sektion, "[data-vivcer-work-item]");
    if (!items.length) return;
    sektion.dataset.vivcerReady = "true";
    const slideIntervall = Math.max(300, Number(sektion.dataset.slideIntervall || 450));
    const slideTimers = new Map();
    const stoppaSlideshow = (pill) => {
      const id = slideTimers.get(pill);
      if (id) window.clearInterval(id);
      slideTimers.delete(pill);
      qa(pill, "[data-vivcer-work-slide]").forEach((slide, i) => {
        slide.dataset.state = i === 0 ? "aktiv" : "idle";
      });
    };
    const startaSlideshow = (pill) => {
      const slides = qa(pill, "[data-vivcer-work-slide]");
      if (slides.length < 2 || V.prefersReducedMotion()) return;
      stoppaSlideshow(pill);
      let ix = slides.findIndex((slide) => slide.dataset.state === "aktiv");
      if (ix < 0) ix = 0;
      const id = window.setInterval(() => {
        slides[ix].dataset.state = "idle";
        ix = (ix + 1) % slides.length;
        slides[ix].dataset.state = "aktiv";
      }, slideIntervall);
      slideTimers.set(pill, id);
    };
    qa(sektion, "[data-vivcer-work-slideshow]").forEach((pill) => {
      const media = pill.closest(".vivcer-work-list__media");
      if (!media) return;
      media.addEventListener("pointerenter", () => startaSlideshow(pill));
      media.addEventListener("pointerleave", () => stoppaSlideshow(pill));
    });
    sektion._vivcerSlideTimers = slideTimers;
    const setHoogte = (panel, open) => {
      if (V.prefersReducedMotion()) {
        panel.style.height = open ? "auto" : "0px";
        return;
      }
      panel.style.transition = `height ${motion.duration * 1000}ms ${motion.cssEase}`;
      if (open) {
        panel.style.height = `${panel.scrollHeight}px`;
        window.setTimeout(() => (panel.style.height = "auto"), motion.duration * 1000);
      } else {
        panel.style.height = `${panel.scrollHeight}px`;
        panel.offsetHeight;
        panel.style.height = "0px";
      }
    };
    items.forEach((item, index) => {
      const btn = item.querySelector("[data-vivcer-work-trigger]");
      const panel = item.querySelector("[data-vivcer-work-panel]");
      if (!btn || !panel) return;
      const id = panel.id || `vivcer-work-panel-${++_panelIdCounter}`;
      panel.id = id;
      btn.setAttribute("aria-controls", id);
      btn.addEventListener("click", () => {
        const open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        item.setAttribute("data-state", open ? "closed" : "open");
        setHoogte(panel, !open);
      });
    });
  };

  const initHeaderKontrast = (root = document) => {
    const header = (root.querySelector && root.querySelector(".vivcer-header")) || document.querySelector(".vivcer-header");
    if (!header || header.dataset.vivcerKontrastReady === "true") return;
    header.dataset.vivcerKontrastReady = "true";
    const provCanvas = document.createElement("canvas");
    const provCtx = provCanvas.getContext("2d", { willReadFrequently: true });
    const parsaRgb = (str) => {
      const m = str && str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
      return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
    };
    const bgArMork = (r, g, b) => {
      const lin = (v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
      };
      return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b) < 0.45;
    };
    const textFranSektion = (kontrast) => (kontrast === "mork" ? "ljus" : "mork");
    const provaBild = (img, x, y) => {
      if (!img?.complete || !img.naturalWidth) return null;
      try {
        const rect = img.getBoundingClientRect();
        const lx = x - rect.left;
        const ly = y - rect.top;
        if (lx < 0 || ly < 0 || lx > rect.width || ly > rect.height) return null;
        const sx = img.naturalWidth / rect.width;
        const sy = img.naturalHeight / rect.height;
        const px = Math.min(img.naturalWidth - 1, Math.max(0, Math.floor(lx * sx)));
        const py = Math.min(img.naturalHeight - 1, Math.max(0, Math.floor(ly * sy)));
        provCanvas.width = 1;
        provCanvas.height = 1;
        provCtx.clearRect(0, 0, 1, 1);
        provCtx.drawImage(img, px, py, 1, 1, 0, 0, 1, 1);
        const data = provCtx.getImageData(0, 0, 1, 1).data;
        if (data[3] < 16) return null;
        return bgArMork(data[0], data[1], data[2]) ? "ljus" : "mork";
      } catch {
        return null;
      }
    };
    const provaElement = (el, x, y) => {
      if (!el || el.closest(".vivcer-header, .vivcer-header__overlay")) return null;
      const marker = el.closest("[data-vivcer-header-kontrast]");
      if (marker) return textFranSektion(marker.dataset.vivcerHeaderKontrast || "ljus");
      const img = el.tagName === "IMG" ? el : el.closest("img");
      if (img) {
        const text = provaBild(img, x, y);
        if (text) return text;
      }
      let node = el;
      while (node && node !== document.documentElement) {
        if (node.closest?.(".vivcer-header")) break;
        const style = getComputedStyle(node);
        const rgb = parsaRgb(style.backgroundColor);
        if (rgb && style.backgroundColor !== "rgba(0, 0, 0, 0)" && style.backgroundImage === "none") {
          return bgArMork(...rgb) ? "ljus" : "mork";
        }
        node = node.parentElement;
      }
      return null;
    };
    const uppdatera = rafThrottle(() => {
      if (header.classList.contains("vivcer-header--menu-open")) return;
      const ram = header.querySelector(".vivcer-header__ram") || header;
      const rect = ram.getBoundingClientRect();
      if (!rect.height) return;
      const y = rect.top + rect.height * 0.5;
      const xs = [0.15, 0.5, 0.85].map((p) => window.innerWidth * p);
      header.setAttribute("data-prov-pekare", "");
      const roster = [];
      xs.forEach((x) => {
        const text = provaElement(document.elementFromPoint(x, y), x, y);
        if (text) roster.push(text);
      });
      header.removeAttribute("data-prov-pekare");
      const next = roster.length
        ? (roster.filter((v) => v === "ljus").length >= roster.filter((v) => v === "mork").length ? "ljus" : "mork")
        : "mork";
      if (header.dataset.headerKontrast !== next) header.dataset.headerKontrast = next;
    });
    const kopplaScroll = () => {
      const lenis = window.VIVCER_LENIS;
      if (lenis && !header._vivcerKontrastScroll) {
        lenis.on("scroll", uppdatera);
        header._vivcerKontrastScroll = true;
      }
    };
    window.addEventListener("scroll", uppdatera, { passive: true });
    window.addEventListener("resize", uppdatera, { passive: true });
    kopplaScroll();
    window.addEventListener("load", kopplaScroll);
    header._vivcerUppdateraKontrast = uppdatera;
    requestAnimationFrame(uppdatera);
  };

  const initHeaderMenu = (sektion) => {
    if (sektion.dataset.vivcerReady === "true") return;
    const toggles = sektion.querySelectorAll("[data-vivcer-menu-toggle]");
    const overlay = sektion.querySelector("[data-vivcer-menu-overlay]");
    const header = sektion.closest(".vivcer-header");
    if (!toggles.length || !overlay) return;
    sektion.dataset.vivcerReady = "true";
    const setOpen = (open) => {
      toggles.forEach(t => {
        t.setAttribute("aria-expanded", open ? "true" : "false");
        t.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      });
      overlay.setAttribute("aria-hidden", open ? "false" : "true");
      if (header) header.classList.toggle("vivcer-header--menu-open", open);
      if (header && !open) header._vivcerUppdateraKontrast?.();
      if (open) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    };
    toggles.forEach(toggle => {
      toggle.addEventListener("click", () => {
        const open = toggle.getAttribute("aria-expanded") !== "true";
        setOpen(open);
      });
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && overlay.getAttribute("aria-hidden") === "false") {
        setOpen(false);
        toggles[0]?.focus();
      }
    });
  };

  const initArticleMosaic = (root) => {
    qa(root, "[data-vivcer-mosaic]").forEach((mosaic) => {
      if (mosaic.dataset.vivcerReady === "true") return;
      mosaic.dataset.vivcerReady = "true";
      const modal = mosaic.querySelector("[data-vivcer-mosaic-modal]");
      const viewport = modal?.querySelector("[data-vivcer-mosaic-modal-viewport]");
      const track = modal?.querySelector("[data-vivcer-mosaic-modal-track]");
      const prevBtn = modal?.querySelector("[data-vivcer-mosaic-prev]");
      const nextBtn = modal?.querySelector("[data-vivcer-mosaic-next]");
      const cursor = modal?.querySelector("[data-vivcer-mosaic-modal-cursor]");
      const cursorUse = modal?.querySelector("[data-vivcer-mosaic-modal-cursor-use]");
      const ikonTyper = V.y2kIkoner || [];
      const triggers = qa(mosaic, "[data-vivcer-mosaic-trigger]");
      if (!modal || !viewport || !track || !triggers.length) return;
      const nastaIkon = () => ikonTyper[Math.floor(Math.random() * ikonTyper.length)] || "stjarnkors";
      const beweegCursor = rafThrottle((event) => {
        if (!cursor) return;
        cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
      });
      const kopplaCursor = (aktiv) => {
        if (!cursor) return;
        if (aktiv) {
          if (cursorUse && ikonTyper.length) cursorUse.setAttribute("href", `#vivcer-y2k-icon-${nastaIkon()}`);
          modal.addEventListener("pointermove", beweegCursor);
          return;
        }
        modal.removeEventListener("pointermove", beweegCursor);
        cursor.style.removeProperty("transform");
      };
      const slides = triggers.map((btn) => {
        const img = btn.querySelector("img");
        const slide = document.createElement("figure");
        slide.className = "vivcer-article-mosaic__modal-slide";
        const slideImg = document.createElement("img");
        slideImg.src = btn.dataset.fullSrc || img?.currentSrc || img?.src || "";
        slideImg.alt = img?.alt || "";
        slideImg.loading = "lazy";
        slideImg.decoding = "async";
        slide.appendChild(slideImg);
        track.appendChild(slide);
        return slide;
      });
      modal.dataset.enSlide = slides.length <= 1 ? "1" : "0";
      let aktivIx = 0;
      let lastTrigger = null;
      const scrollTill = (ix) => {
        if (!slides.length) return;
        aktivIx = (ix + slides.length) % slides.length;
        viewport.scrollTo({ left: slides[aktivIx].offsetLeft, behavior: "auto" });
      };
      const syncAktiv = rafThrottle(() => {
        if (!slides.length) return;
        const mitt = viewport.scrollLeft + viewport.clientWidth * 0.5;
        let nasta = aktivIx;
        let minDist = Infinity;
        slides.forEach((slide, i) => {
          const cx = slide.offsetLeft + slide.offsetWidth * 0.5;
          const dist = Math.abs(cx - mitt);
          if (dist < minDist) { minDist = dist; nasta = i; }
        });
        aktivIx = nasta;
      });
      viewport.addEventListener("scroll", syncAktiv, { passive: true });
      const shut = () => {
        modal.setAttribute("aria-hidden", "true");
        kopplaCursor(false);
        lastTrigger?.focus();
        lastTrigger = null;
      };
      const open = (btn, event) => {
        const ix = triggers.indexOf(btn);
        if (ix < 0) return;
        lastTrigger = btn;
        modal.setAttribute("aria-hidden", "false");
        kopplaCursor(true);
        if (event && cursor) beweegCursor(event);
        requestAnimationFrame(() => scrollTill(ix));
      };
      triggers.forEach((btn) => btn.addEventListener("click", (event) => open(btn, event)));
      prevBtn?.addEventListener("click", (event) => (event.stopPropagation(), scrollTill(aktivIx - 1)));
      nextBtn?.addEventListener("click", (event) => (event.stopPropagation(), scrollTill(aktivIx + 1)));
      modal.addEventListener("click", (event) => {
        if (event.target === modal) shut();
      });
      let pekStart = null;
      viewport.addEventListener("pointerdown", (event) => {
        pekStart = { x: event.clientX, y: event.clientY };
      });
      viewport.addEventListener("click", (event) => {
        if (!pekStart) return;
        const dx = Math.abs(event.clientX - pekStart.x);
        const dy = Math.abs(event.clientY - pekStart.y);
        pekStart = null;
        if (dx > 10 || dy > 10) return;
        if (event.target.closest(".vivcer-article-mosaic__modal-slide")) shut();
      });
      mosaic._vivcerMosaicEsc = (event) => {
        if (modal.getAttribute("aria-hidden") === "true") return;
        if (event.key === "Escape") shut();
        if (event.key === "ArrowLeft") { event.preventDefault(); scrollTill(aktivIx - 1); }
        if (event.key === "ArrowRight") { event.preventDefault(); scrollTill(aktivIx + 1); }
      };
      document.addEventListener("keydown", mosaic._vivcerMosaicEsc);
      const tiles = qa(mosaic, "[data-reveal]");
      if (!tiles.length) return;
      if (!window.IntersectionObserver) {
        tiles.forEach((tile) => (tile.dataset.state = "revealed"));
        return;
      }
      const io = new window.IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.dataset.state = "revealed";
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.08, rootMargin: "0px 0px -4% 0px" }
      );
      tiles.forEach((tile) => {
        if (tile.dataset.state !== "revealed") io.observe(tile);
      });
    });
  };

  const initEditorialReveal = (root) => {
    const scope = root === document ? document.body : root;
    const targets = qa(scope, "[data-reveal]").filter((el) => !el.closest("[data-vivcer-mosaic]"));
    if (!targets.length) return;

    if (!window.IntersectionObserver) {
      targets.forEach((el) => (el.dataset.state = "revealed"));
      return;
    }

    const io = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.dataset.state = "revealed";
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -5% 0px" }
    );

    targets.forEach((el) => {
      if (el.dataset.state !== "revealed") io.observe(el);
    });
  };

  const initKategoriFilter = (root) => {
    const { animate } = window.anime || {};
    const figurMotion = (state, targets) => {
      if (!animate || V.prefersReducedMotion()) return [];
      const { layer } = targets;
      const dur = motion.duration * 1400;
      const easeFlow = "inOut(2)";
      const easeSettle = "out(3)";
      const runs = [];
      if (state === "idle") {
        layer && runs.push(animate(layer, { rotate: 0, scale: 1, duration: dur * 0.6, ease: easeSettle }));
      } else if (state === "hovered") {
        layer && runs.push(animate(layer, { rotate: 14, scale: 1.08, duration: dur, ease: easeFlow, composition: "blend" }));
      } else {
        layer && runs.push(animate(layer, { rotate: 8, scale: 1.04, duration: dur * 0.85, ease: easeSettle }));
      }
      return runs;
    };
    const blandaIkoner = (ikoner) => {
      const pool = [...ikoner];
      for (let i = pool.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      return pool;
    };
    const tilldelaY2kIkoner = (filterEl) => {
      if (!filterEl.matches("[data-y2k-ikoner]")) return;
      const ikonTyper = V.y2kIkoner || [];
      if (!ikonTyper.length) return;
      const pool = blandaIkoner(ikonTyper);
      let poolIx = 0;
      const nasta = () => pool[poolIx++ % pool.length];
      qa(filterEl, "[data-vivcer-kf-option]").forEach((option) => {
        const typ = nasta();
        option.dataset.figur = typ;
        const use = option.querySelector(".vivcer-kategori-filter__figur use");
        if (use) use.setAttribute("href", `#vivcer-y2k-icon-${typ}`);
      });
    };
    qa(root, "[data-vivcer-kategori-filter]").forEach((filterEl) => {
      if (filterEl.dataset.vivcerReady === "true") return;
      filterEl.dataset.vivcerReady = "true";
      tilldelaY2kIkoner(filterEl);
      const scope = filterEl.closest("[data-vivcer-kf-scope]") || filterEl.closest("section");
      const columns = scope ? qa(scope, "[data-vivcer-kf-column]") : [];
      const items = scope ? qa(scope, "[data-vivcer-kf-item]") : [];
      const options = qa(filterEl, "[data-vivcer-kf-option]");
      const figurRuns = new WeakMap();
      const cancelFigur = (option) => {
        figurRuns.get(option)?.forEach((run) => run?.cancel?.());
        figurRuns.set(option, []);
      };
      const setOptionState = (option, state) => {
        if (!option) return;
        option.dataset.state = state;
        cancelFigur(option);
        figurRuns.set(option, figurMotion(state, { layer: option.querySelector(".vivcer-kategori-filter__layer") }));
      };
      const syncOptionStates = () => {
        options.forEach((option) => {
          setOptionState(option, option.querySelector("input")?.checked ? "aktiv" : "idle");
        });
      };
      options.forEach((option) => {
        option.addEventListener("pointerenter", () => {
          if (!option.querySelector("input")?.checked) setOptionState(option, "hovered");
        });
        option.addEventListener("pointerleave", () => {
          if (!option.querySelector("input")?.checked) setOptionState(option, "idle");
        });
      });
      const applyFilter = (value) => {
        if (!columns.length || !items.length) return;
        const visible = items.filter((item) => {
          const cat = item.dataset.category || "";
          return !value || cat === value;
        });
        columns.forEach((col) => col.replaceChildren());
        visible.forEach((item, i) => columns[i % columns.length].appendChild(item));
        items.forEach((item) => {
          item.setAttribute("aria-hidden", visible.includes(item) ? "false" : "true");
        });
      };
      qa(filterEl, "[data-vivcer-kf-option] input").forEach((input) => {
        input.addEventListener("change", () => {
          if (input.checked) {
            applyFilter(input.value);
            syncOptionStates();
          }
        });
      });
      if (options.length) applyFilter("");
      syncOptionStates();
    });
  };

  const initProjectFeed = (root) => {
    const desktop = window.matchMedia("(min-width: 750px)");
    const blandaIkoner = (ikoner) => {
      const pool = [...ikoner];
      for (let i = pool.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      return pool;
    };
    qa(root, "[data-vivcer-project-feed]").forEach((section) => {
      if (section.dataset.vivcerFeedReady === "true") return;
      section.dataset.vivcerFeedReady = "true";
      qa(section, "[data-vivcer-kf-item]").forEach((card) => {
        card.addEventListener("mouseenter", () => {
          card.scrollIntoView({ behavior: "smooth", block: "nearest" });
        });
      });
      if (!desktop.matches) return;
      const cursor = section.querySelector("[data-vivcer-pf-cursor]");
      const useEl = section.querySelector("[data-vivcer-pf-cursor-use]");
      const layer = section.querySelector(".vivcer-project-feed__cursor-layer");
      const mediaTargets = qa(section, "[data-vivcer-kf-item] .vivcer-project-feed__card-media");
      const ikonTyper = V.y2kIkoner || [];
      if (!cursor || !useEl || !mediaTargets.length || !ikonTyper.length) return;
      const { animate } = window.anime || {};
      let motionRun = null;
      const cancelMotion = () => {
        motionRun?.cancel?.();
        motionRun = null;
      };
      const startHoverLoop = () => {
        cancelMotion();
        if (!animate || V.prefersReducedMotion() || !layer) return;
        const dur = motion.duration * 2800;
        motionRun = animate(layer, {
          rotate: [-12, 16],
          scale: [0.94, 1.1],
          duration: dur,
          ease: "inOut(2)",
          alternate: true,
          loop: true,
          composition: "blend"
        });
      };
      const stopHoverLoop = () => {
        cancelMotion();
        if (!animate || V.prefersReducedMotion() || !layer) return;
        motionRun = animate(layer, {
          rotate: 0,
          scale: 1,
          duration: motion.duration * 900,
          ease: "out(3)"
        });
      };
      const pool = blandaIkoner(ikonTyper);
      let poolIx = 0;
      const nastaIkon = () => pool[poolIx++ % pool.length];
      const provCanvas = document.createElement("canvas");
      const provCtx = provCanvas.getContext("2d", { willReadFrequently: true });
      qa(section, ".vivcer-project-feed__card-img").forEach((img) => {
        if (img.crossOrigin !== "anonymous") img.crossOrigin = "anonymous";
      });
      const hamtaHoverBild = (media) =>
        media.querySelector(".vivcer-project-feed__card-img--secondary") ||
        media.querySelector(".vivcer-project-feed__card-img--primary") ||
        media.querySelector(".vivcer-project-feed__card-img");
      const invertAreaFarg = (img, clientX, clientY) => {
        if (!img?.complete || !img.naturalWidth) return null;
        try {
          const rect = img.getBoundingClientRect();
          if (!rect.width || !rect.height) return null;
          const lx = clientX - rect.left;
          const ly = clientY - rect.top;
          if (lx < 0 || ly < 0 || lx > rect.width || ly > rect.height) return null;
          const sx = img.naturalWidth / rect.width;
          const sy = img.naturalHeight / rect.height;
          const px = Math.min(img.naturalWidth - 1, Math.max(0, Math.floor(lx * sx)));
          const py = Math.min(img.naturalHeight - 1, Math.max(0, Math.floor(ly * sy)));
          const rad = 1;
          const ox = Math.max(0, px - rad);
          const oy = Math.max(0, py - rad);
          const sw = Math.min(rad * 2 + 1, img.naturalWidth - ox);
          const sh = Math.min(rad * 2 + 1, img.naturalHeight - oy);
          provCanvas.width = sw;
          provCanvas.height = sh;
          provCtx.clearRect(0, 0, sw, sh);
          provCtx.drawImage(img, ox, oy, sw, sh, 0, 0, sw, sh);
          const data = provCtx.getImageData(0, 0, sw, sh).data;
          let r = 0, g = 0, b = 0, n = 0;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 16) continue;
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
            n += 1;
          }
          if (!n) return null;
          r = Math.round(r / n);
          g = Math.round(g / n);
          b = Math.round(b / n);
          return `rgb(${255 - r}, ${255 - g}, ${255 - b})`;
        } catch {
          return null;
        }
      };
      const uppdateraCursorFarg = (media, event) => {
        const img = hamtaHoverBild(media);
        if (!img) return;
        const farg = invertAreaFarg(img, event.clientX, event.clientY);
        if (farg) {
          cursor.style.setProperty("--vivcer-pf-cursor-farg", farg);
          cursor.removeAttribute("data-vivcer-pf-cursor-fallback");
        } else {
          cursor.style.removeProperty("--vivcer-pf-cursor-farg");
          cursor.setAttribute("data-vivcer-pf-cursor-fallback", "");
        }
      };
      const rensaCursorFarg = () => {
        cursor.style.removeProperty("--vivcer-pf-cursor-farg");
        cursor.removeAttribute("data-vivcer-pf-cursor-fallback");
      };
      mediaTargets.forEach((media) => {
        media.dataset.figur = nastaIkon();
      });
      let aktivMedia = null;
      const beweeg = rafThrottle((event) => {
        cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
        if (aktivMedia) uppdateraCursorFarg(aktivMedia, event);
      });
      mediaTargets.forEach((media) => {
        media.addEventListener("pointerenter", (event) => {
          if (event.pointerType !== "mouse" || !desktop.matches) return;
          aktivMedia = media;
          useEl.setAttribute("href", `#vivcer-y2k-icon-${media.dataset.figur || ikonTyper[0]}`);
          section.setAttribute("data-cursor-active", "");
          startHoverLoop();
          beweeg(event);
        });
        media.addEventListener("pointermove", (event) => {
          if (event.pointerType !== "mouse" || !desktop.matches) return;
          beweeg(event);
        });
        media.addEventListener("pointerleave", (event) => {
          if (event.pointerType !== "mouse") return;
          aktivMedia = null;
          section.removeAttribute("data-cursor-active");
          rensaCursorFarg();
          stopHoverLoop();
        });
      });
      desktop.addEventListener("change", () => {
        if (desktop.matches) return;
        aktivMedia = null;
        section.removeAttribute("data-cursor-active");
        rensaCursorFarg();
        cancelMotion();
      });
    });
  };

  const initFilterableGrid = (root) => {
    qa(root, "[data-vivcer-fg]").forEach((section) => {
      if (section.dataset.vivcerReady === "true") return;
      section.dataset.vivcerReady = "true";

      const grid    = section.querySelector("[data-vivcer-fg-grid]");
      const filters = qa(section, "[data-vivcer-fg-filter] input");
      const tiles   = qa(section, "[data-vivcer-fg-tile]");
      if (!grid || !filters.length) return;

      const applyFilter = (value) => {
        tiles.forEach((tile) => {
          const cat = tile.dataset.category || "";
          const visible = !value || cat === value;
          tile.dataset.state = visible ? "" : "hidden";
          tile.setAttribute("aria-hidden", visible ? "false" : "true");
        });
      };

      filters.forEach((input) => {
        input.addEventListener("change", () => {
          if (input.checked) applyFilter(input.value);
        });
      });

      applyFilter("");
    });
  };

  const initWorkPage = (root) => {
    qa(root, "[data-vivcer-wp-card]").forEach((card) => {
      if (card.dataset.vivcerReady === "true") return;
      card.dataset.vivcerReady = "true";
      const gallery = card.querySelector("[data-vivcer-wp-gallery]");
      const track   = card.querySelector("[data-vivcer-wp-track]");
      if (!track) return;
      const slides = qa(track, ".vivcer-work-page__slide");
      if (slides.length < 2) return;
      let aktiv = 0;
      const uppdatera = () => track.style.setProperty("--vivcer-slide-index", aktiv);
      gallery && gallery.addEventListener("pointerenter", () => { aktiv = 1; uppdatera(); });
      gallery && gallery.addEventListener("pointerleave", () => { aktiv = 0; uppdatera(); });
      uppdatera();
    });
  };

  const initStepForm = (root) => {
    qa(root, "[data-vivcer-step-form]").forEach((form) => {
      if (form.dataset.vivcerReady === "true") return;
      form.dataset.vivcerReady = "true";

      const setState = (state) => {
        form.dataset.state = state;
        qa(form, "[data-step]").forEach((step) => {
          const match = step.dataset.step === state;
          step.hidden = !match;
        });
        const openBtn = form.querySelector("[data-action='step-form/open']");
        if (openBtn) openBtn.setAttribute("aria-expanded", state === "input" ? "true" : "false");
      };

      const getEmailInput = () => form.querySelector("[type='email']");
      const getErrEl     = () => form.querySelector("[data-action='step-form/submit']")?.closest("form")?.querySelector("[role='alert']")
                               || form.querySelector(".vivcer-teaching__error");

      form.addEventListener("click", (e) => {
        const action = e.target.closest("[data-action]")?.dataset.action;
        if (!action) return;

        if (action === "step-form/open") {
          setState("input");
          const inp = getEmailInput();
          inp && setTimeout(() => inp.focus(), 50);
          return;
        }

        if (action === "step-form/close") {
          setState("idle");
          const openBtn = form.querySelector("[data-action='step-form/open']");
          openBtn && openBtn.focus();
          return;
        }

        if (action === "step-form/retry") {
          setState("input");
          const inp = getEmailInput();
          inp && setTimeout(() => inp.focus(), 50);
          return;
        }
      });

      form.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && form.dataset.state === "input") {
          setState("idle");
          const openBtn = form.querySelector("[data-action='step-form/open']");
          openBtn && openBtn.focus();
        }
      });

      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formEl   = e.target.closest("form");
        if (!formEl) return;
        const formType = formEl.dataset.formType;
        const emailInp = formEl.querySelector("[type='email']");
        const errEl    = formEl.querySelector("[role='alert']");
        if (!emailInp) return;

        const email = emailInp.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (errEl) { errEl.textContent = "Please enter a valid email address."; errEl.hidden = false; }
          emailInp.focus();
          return;
        }
        if (errEl) errEl.hidden = true;

        setState("loading");

        try {
          const tag  = formType === "waitlist" ? "waitlist" : "newsletter";
          const body = new URLSearchParams({
            "contact[email]": email,
            "contact[tags]":  tag,
            "form_type":      "customer",
            "utf8":           "✓"
          });
          const res = await fetch("/contact#contact_form", {
            method:  "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
            body:    body.toString()
          });
          if (res.ok) {
            setState("success");
          } else {
            setState("error");
          }
        } catch {
          setState("error");
        }
      });

      setState("idle");
    });
  };

  const initCollectionList = (root) => {
    qa(root, "[data-vivcer-product-card]").forEach((card) => {
      if (card.dataset.vivcerReady === "true") return;
      card.dataset.vivcerReady = "true";
      const gallery = card.querySelector("[data-vivcer-product-gallery]");
      const track = card.querySelector("[data-vivcer-gallery-track]");
      const controls = card.querySelector("[data-vivcer-product-controls]");
      const current = controls ? controls.querySelector("[data-vivcer-current]") : null;
      const total = controls ? controls.querySelector("[data-vivcer-total]") : null;
      if (!track) return;
      const slides = qa(track, ".vivcer-col-list__slide");
      const count = slides.length;
      const fmt = (ix) => String(ix + 1).padStart(2, "0");
      total && (total.textContent = fmt(count - 1));
      let aktiv = 0;
      const uppdatera = () => {
        gallery && gallery.style.setProperty("--vivcer-slide-index", aktiv);
        track.style.setProperty("--vivcer-slide-index", aktiv);
        current && (current.textContent = fmt(aktiv));
      };
      if (count > 1) {
        controls && controls.querySelector("[data-vivcer-prev]")?.addEventListener("click", () => (aktiv = (aktiv - 1 + count) % count, uppdatera()));
        controls && controls.querySelector("[data-vivcer-next]")?.addEventListener("click", () => (aktiv = (aktiv + 1) % count, uppdatera()));
        gallery && gallery.addEventListener("pointerenter", () => (aktiv = 1, uppdatera()));
        gallery && gallery.addEventListener("pointerleave", () => (aktiv = 0, uppdatera()));
      } else {
        controls && controls.querySelectorAll("[data-vivcer-prev],[data-vivcer-next]").forEach(b => (b.disabled = true, b.setAttribute("aria-disabled", "true")));
      }
      uppdatera();
    });
  };

  const initIconText = (root) => {
    const ikonTyper = V.y2kIkoner || [];
    const skapaIkon = () => {
      if (!ikonTyper.length) return document.createDocumentFragment();
      const typ = ikonTyper[Math.floor(Math.random() * ikonTyper.length)];
      const span = document.createElement("span");
      span.className = "vivcer-icon-text__ikon";
      span.dataset.figur = typ;
      span.setAttribute("aria-hidden", "true");
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.setAttribute("class", "vivcer-icon-text__svg");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
      use.setAttribute("href", `#vivcer-y2k-icon-${typ}`);
      svg.appendChild(use);
      span.appendChild(svg);
      return span;
    };
    qa(root, "[data-vivcer-icon-text-body]").forEach((body) => {
      const sektion = body.closest("[data-vivcer-icon-text]");
      const intervall = Math.max(2, Number(sektion?.dataset.intervall || 4));
      if (!body.dataset.vivcerIconTextKalla) body.dataset.vivcerIconTextKalla = body.innerHTML;
      else body.innerHTML = body.dataset.vivcerIconTextKalla;
      if (body.dataset.vivcerReady === "true") return;
      body.dataset.vivcerReady = "true";
      let ord = 0;
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      const textNoder = [];
      while (walker.nextNode()) textNoder.push(walker.currentNode);
      textNoder.forEach((node) => {
        const bitar = node.textContent.split(/(\s+)/);
        if (bitar.length <= 1) return;
        const frag = document.createDocumentFragment();
        for (let i = 0; i < bitar.length; i += 1) {
          const bit = bitar[i];
          if (!bit) continue;
          if (!/\S/.test(bit)) {
            if (frag.lastChild?.classList?.contains("vivcer-icon-text__ikon")) continue;
            frag.appendChild(document.createTextNode(bit));
            continue;
          }
          ord += 1;
          frag.appendChild(document.createTextNode(bit));
          if (ord % intervall !== 0) continue;
          frag.appendChild(skapaIkon());
          if (bitar[i + 1] && !/\S/.test(bitar[i + 1])) i += 1;
        }
        node.replaceWith(frag);
      });
    });
  };

  const init = () => {
    initHeaderKontrast(document);
    qa(document, "[data-vivcer-sektion]").forEach((sektion) => {
      const typ = sektion.dataset.vivcerSektion || "";
      if (typ === "horizontal-gallery") initHorGallery(sektion);
      if (typ === "footer-accordion") initFooterAccordion(sektion);
      if (typ === "split-screen") initSplitScreen(sektion);
      if (typ === "rolling-gallery") initRollingGallery(sektion);
      if (typ === "work-list") initWorkList(sektion);
      if (typ === "header") initHeaderMenu(sektion);
    });
    initModularGrid(document);
    initArticleSlideshows(document);
    initCollectionList(document);
    initWorkPage(document);
    initStepForm(document);
    initFilterableGrid(document);
    initKategoriFilter(document);
    initProjectFeed(document);
    initIconText(document);
    initArticleMosaic(document);
    initEditorialReveal(document);
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", (event) => {
    initHeaderKontrast(event.target);
    init();
    initModularGrid(event.target);
    initArticleSlideshows(event.target);
    initCollectionList(event.target);
    initWorkPage(event.target);
    initStepForm(event.target);
    initFilterableGrid(event.target);
    initKategoriFilter(event.target);
    initProjectFeed(event.target);
    initIconText(event.target);
    initArticleMosaic(event.target);
    initEditorialReveal(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    qa(event.target, "[data-vivcer-mosaic]").forEach((mosaic) => {
      if (mosaic._vivcerMosaicEsc) document.removeEventListener("keydown", mosaic._vivcerMosaicEsc);
    });
    const sektion = event.target.querySelector?.("[data-vivcer-sektion='work-list']");
    const timers = sektion?._vivcerSlideTimers;
    if (!timers) return;
    timers.forEach((id, pill) => {
      window.clearInterval(id);
      V.qa(pill, "[data-vivcer-work-slide]").forEach((slide, i) => {
        slide.dataset.state = i === 0 ? "aktiv" : "idle";
      });
    });
    timers.clear();
  });
})();
